import { useQuery } from "react-query";
import useNetworkHeaders from "../../../hooks/useNetworkHeaders";
import { postNotifyNotificationContentInfo, PostNotifyNotificationContentInfoBody } from "../../../queries/notify";

export function useNotifyNotificationInfo({ body }: { body: PostNotifyNotificationContentInfoBody }) {
  const networkHeaders = useNetworkHeaders();

  const { data: notificationInfo, isLoading: isNotificationInfoLoading } = useQuery(
    buildNotifyNotificationInfoQueryKey(body),
    postNotifyNotificationContentInfo(networkHeaders),
    {
      queryFnParamsFilter(args) {
        return [args[1]];
      },
    },
  );

  return {
    notificationInfo,
    isNotificationInfoLoading,
  };
}

export function buildNotifyNotificationInfoQueryKey(body: PostNotifyNotificationContentInfoBody) {
  return ["notifyNotificationInfo", body];
}
